import React, { Fragment, useEffect, useState } from 'react'
import { FiEdit2, FiEye, FiTrash2 } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import { MdOutlineClose } from 'react-icons/md'
import { RiAlertFill } from 'react-icons/ri'
import toast from 'react-hot-toast'

import columns from './columns'
import CustomModal from '../../components/common/CustomModal'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'

const City = () => {
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedCity, setSelectedCity] = useState(null)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('city/list')
      if (response.status === 200) {
        const transformedData = response?.data?.result?.docs?.map((item) => ({
          ...item,
          actions: (
            <div className='flex items-center'>
              {/* <div className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary">
                <Link to={`${item._id}`}>
                  <FiEye className="w-4 h-4" />
                </Link>
              </div> */}
              <div
                className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                onClick={() => handleOpenDeleteModal(item._id)}
              >
                <FiTrash2 className='w-4 h-4' />
              </div>
              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`edit/${item._id}`}>
                  <FiEdit2 className='w-4 h-4' />
                </Link>
              </div>
            </div>
          ),
        }))
        setData(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleOpenDeleteModal = (id) => {
    setSelectedCity(id)
    setIsModalOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setIsModalOpen(false)
    setSelectedCity(null)
  }
  const handleDelete = async () => {
    setIsDeleteLoading(true)
    try {
      const response = await axiosAuthInstance.delete(
        `city/delete/${selectedCity}`,
      )
      if (response.status === 200) {
        fetchData()
        setIsDeleteLoading(false)
        setIsModalOpen(false)
      }
    } catch (error) {
      setIsDeleteLoading(false)
      setIsModalOpen(false)
    }
  }

  return (
    <Fragment>
      <div className='flex items-center justify-between border-b px-4 pb-2'>
        <h1 className='text-2xl'>City</h1>
        <Link to='/city/add'>
          <button className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'>
            Add
          </button>
        </Link>
      </div>
      <DataTable columns={columns} data={data} />

      {isModalOpen && (
        <CustomModal handleCloseModal={handleCloseDeleteModal}>
          <div className='p-4 relative'>
            <div
              className=' absolute right-5 cursor-pointer hover:opacity-70'
              onClick={handleCloseDeleteModal}
            >
              <MdOutlineClose className=' text-2xl' />
            </div>
            <div className=' flex flex-col items-center justify-between gap-4'>
              <div className='flex flex-wrap justify-center alert-ico'>
                <RiAlertFill className=' text-5xl' />
              </div>
              <h2>Are you sure you want to delete this City?</h2>
              <div className='flex gap-4 mt-4'>
                <button
                  onClick={handleCloseDeleteModal}
                  className='bg-gray-300 px-4 py-2 rounded'
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className='bg-red-500 text-white px-4 py-2 rounded'
                >
                  {isDeleteLoading ? (
                    <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent' />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </Fragment>
  )
}

export default City
